import { connect } from 'react-redux';
import PaymentStepStatus from './PaymentStepStatus';

const mapStateToProps = ({ purchase }) => ({
  isExchange: purchase.get('isExchange'),
});

export default connect(mapStateToProps)(PaymentStepStatus);
